import React from 'react'
import { ContainerPages } from '../components/Containers'
import { TemplateListInfos } from '../templates/User/ListInfos'

export const ListInfos: React.FC = () => {
  return (
    <ContainerPages>
      <TemplateListInfos />
    </ContainerPages>
  )
}
